import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import { Button, MenuItem, Select } from '@material-ui/core';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { CALENDAR_VIEW, DATE_FORMAT, DISPLAY_DATE_FORMAT } from '../../../constants/DashboardConst';
import {
  setDashboardCalendarType,
  setDashboardFilterDate,
} from '../../../layouts/home/DashboardSlice';
import './Custom-Calendar-View.scss';

const CustomCalendarView = (props) => {
  const { date, calendarType, calendarRef, events, filterEvent, selectedValue, countTitle } = props;
  const dispatch = useDispatch();
  const [eventList, setEventList] = useState([]);

  useEffect(() => {
    const scrollDiv = document.getElementsByClassName('fc-scroller-liquid-absolute');
    scrollDiv[0]?.classList?.add('scroll-styled');
  }, []);

  useEffect(() => {
    if (calendarType === 'timeGridDay' || calendarType === 'timeGridWeek') setEventList(events);
    else if (calendarType === 'dayGridMonth') {
      const currentEvent = [];
      events.forEach((eventList) => {
        const appointmentDate = moment(
          eventList.extendedProps.appointmentDate,
          'YYYY-MM-DD',
        ).format('YYYY-MM-DD');
        const eventCount = currentEvent.filter(
          (currEvent) => currEvent?.extendedProps?.appointmentDate === appointmentDate,
        );
        if (eventCount.length < 3) currentEvent.push({ ...eventList });
      });
      setEventList(currentEvent);
    }
  }, [events]);

  const handleViewChange = (view) => {
    const calendar = calendarRef?.current.getApi();
    const formatDate = moment().format(DATE_FORMAT);
    dispatch(setDashboardCalendarType(view));
    calendar.changeView(view);
    calendar.today();
    const currDate = { ...date };
    switch (view) {
      case 'timeGridDay':
        currDate.displayDate = moment().format(DISPLAY_DATE_FORMAT);
        currDate.formatDate = formatDate;
        currDate.startDate = '';
        break;
      case 'timeGridWeek':
        const startWeek = moment().startOf('week').format(DISPLAY_DATE_FORMAT);
        const endWeek = moment().endOf('week').format(DISPLAY_DATE_FORMAT);
        currDate.displayDate = `${startWeek} to ${endWeek}`;
        currDate.formatDate = moment(endWeek, DISPLAY_DATE_FORMAT).format(DATE_FORMAT);
        currDate.startDate = moment(startWeek, DISPLAY_DATE_FORMAT).format(DATE_FORMAT);
        break;
      case 'dayGridMonth':
        currDate.displayDate = moment().format('MMM');
        currDate.formatDate = formatDate;
        currDate.startDate = '';
        break;
      default:
        break;
    }
    dispatch(setDashboardFilterDate(currDate));
    filterEvent(currDate, selectedValue, view);
  };

  useEffect(() => {
    handleViewChange('timeGridDay');
  }, []);

  const setAddSubtractType = () => {
    if (calendarType === 'timeGridDay')
      return {
        type: 'day',
        displayDate: DISPLAY_DATE_FORMAT,
        formatDate: DATE_FORMAT,
      };
    if (calendarType === 'timeGridWeek')
      return {
        type: 'week',
        displayDate: DISPLAY_DATE_FORMAT,
        formatDate: DATE_FORMAT,
      };
    if (calendarType === 'dayGridMonth')
      return { type: 'month', displayDate: 'MMM', formatDate: DATE_FORMAT };
  };

  const onDateChange = (type) => {
    let currDate = { ...date };
    const addSubtractType = setAddSubtractType();
    if (type === 'previous') {
      if (calendarType === 'timeGridWeek') {
        const startWeek = moment(date.formatDate)
          .subtract(1, addSubtractType.type)
          .startOf('week')
          .format(DISPLAY_DATE_FORMAT);
        const endWeek = moment(date.formatDate)
          .subtract(1, addSubtractType.type)
          .endOf('week')
          .format(DISPLAY_DATE_FORMAT);
        currDate.displayDate = `${startWeek} to ${endWeek}`;
        currDate.formatDate = moment(endWeek, DISPLAY_DATE_FORMAT).format(
          addSubtractType.formatDate,
        );
        currDate.startDate = moment(startWeek, DISPLAY_DATE_FORMAT).format(
          addSubtractType.formatDate,
        );
      } else {
        currDate.formatDate = moment(date.formatDate, DATE_FORMAT)
          .subtract(1, addSubtractType.type)
          .format(addSubtractType.formatDate);
        currDate.displayDate = moment(date.formatDate, DATE_FORMAT)
          .subtract(1, addSubtractType.type)
          .format(addSubtractType.displayDate);
        currDate.startDate = '';
      }
      calendarRef?.current.getApi().prev();
    } else {
      if (calendarType === 'timeGridWeek') {
        const startWeek = moment(date.formatDate, DATE_FORMAT)
          .add(1, addSubtractType.type)
          .startOf('week')
          .format(DISPLAY_DATE_FORMAT);
        const endWeek = moment(date.formatDate, DATE_FORMAT)
          .add(1, addSubtractType.type)
          .endOf('week')
          .format(DISPLAY_DATE_FORMAT);
        currDate.displayDate = `${startWeek} to ${endWeek}`;
        currDate.formatDate = moment(endWeek, DISPLAY_DATE_FORMAT).format(
          addSubtractType.formatDate,
        );
        currDate.startDate = moment(startWeek, DISPLAY_DATE_FORMAT).format(
          addSubtractType.formatDate,
        );
      } else {
        currDate.formatDate = moment(date.formatDate, DATE_FORMAT)
          .add(1, addSubtractType.type)
          .format(addSubtractType.formatDate);
        currDate.displayDate = moment(date.formatDate, DATE_FORMAT)
          .add(1, addSubtractType.type)
          .format(addSubtractType.displayDate);
        currDate.startDate = '';
      }
      calendarRef?.current.getApi().next();
    }
    dispatch(setDashboardFilterDate(currDate));
    filterEvent(currDate, selectedValue, calendarType);
  };

  const displayDayHeader = () => {
    if (calendarType === 'timeGridDay') return false;
    if (calendarType === 'timeGridWeek' || calendarType === 'dayGridMonth') return true;
    return false;
  };

  const renderDayHeaderContent = (e) => {
    if (calendarType === 'timeGridWeek') {
      const dayName = moment(e.date).format('ddd');
      const date = moment(e.date).format('DD');
      return (
        <div className={e.isToday ? 'current-day-header' : 'day-header'}>
          <div>{dayName}</div>
          <div>{date}</div>
        </div>
      );
    }
    return undefined;
  };

  const getSameTimecount = (time, appointmentDate) => {
    return events.filter((e) => {
      const startTime = moment(e.start).format('h:mm');
      const endTime = moment(e.end).format('h:mm');
      const slotTime = `${startTime} - ${endTime}`;
      if (!time && e.extendedProps.appointmentDate === appointmentDate) return true;
      if (slotTime === time && e.extendedProps.appointmentDate === appointmentDate) return true;
    });
  };

  const setShorTitle = (title) => {
    if (title.length > 10) return `${title.slice(0, 10)}...`;
    return title;
  };

  const setDayFontSize = (sameTimecount) => {
    if (sameTimecount > 5) return '9px';
    if (sameTimecount > 3) return '10px';
    return '14px';
  };

  const renderDayEvent = (e, sameTimecount) => (
    <div
      className={`event-box-content ${countTitle === 'Bookings' ? 'align-self-center' : ''}`}
      style={{ fontSize: setDayFontSize(sameTimecount) }}
    >
      <span
        className='event-box-content-name'
        style={{
          color: e.event.extendedProps.status === 'New Request' ? '#000000' : '#707070',
          marginRight: sameTimecount > 4 ? '0px' : '21px',
        }}
      >
        {e.event.extendedProps.name}
      </span>
      {e.event.extendedProps.type === 'spa' && sameTimecount === 1 && (
        <span
          style={{
            color: e.event.extendedProps.status === 'New Request' ? '#0B353F' : '#707070',
          }}
        >
          -{e.event.title}
        </span>
      )}
      {e.event.extendedProps.type === 'restaurant' &&
        e.event.extendedProps.status === 'New Request' && (
          <span
            style={{
              color: e.event.extendedProps.status === 'New Request' ? '#0B353F' : '#707070',
            }}
          >
            - {e.event.extendedProps.guestNo} Guest
          </span>
        )}
      <p className='event-box-content-time'>
        {e.event.extendedProps.table ? e.event.extendedProps.table : e.timeText}
      </p>
    </div>
  );

  const renderWeekEvent = (e, sameTimecount) => (
    <div
      className='event-box-content-week align-self-center'
      style={{ fontSize: sameTimecount === 1 ? '10px' : '5px' }}
    >
      <div>{e.event.extendedProps.name}</div>
      {sameTimecount === 1 && (
        <>
          <div>{e.timeText}</div>
          <div>{setShorTitle(e.event.title)}</div>
        </>
      )}
    </div>
  );

  const renderMonthEvent = (e) => (
    <div className='event-box-content-month'>
      <div>{e.event.extendedProps.name}</div>
    </div>
  );

  const renderEventContent = (e) => {
    const sameTimecount = getSameTimecount(e.timeText, e.event.extendedProps.appointmentDate);
    return (
      <div
        className='d-flex event-box'
        style={{ backgroundColor: e.event.extendedProps.backgroundColor }}
      >
        <div
          className='event-box-side'
          style={{
            backgroundColor: e.event.extendedProps.sideColor,
            marginRight:
              calendarType === 'timeGridWeek' || calendarType === 'dayGridMonth' ? '2px' : '20px',
          }}
        />
        {calendarType === 'timeGridDay' && renderDayEvent(e, sameTimecount?.length)}
        {calendarType === 'timeGridWeek' && renderWeekEvent(e, sameTimecount?.length)}
        {calendarType === 'dayGridMonth' && renderMonthEvent(e)}
      </div>
    );
  };

  const renderDayCellContent = (e) => {
    const eventCount = getSameTimecount(null, moment(e.date).format('YYYY-MM-DD'));
    if (calendarType === 'dayGridMonth') {
      return (
        <div className='d-flex justify-content-between'>
          <div
            className={
              moment().format('YYYY-MM-DD') === moment(e.date).format('YYYY-MM-DD')
                ? 'current-month-day'
                : 'month-day'
            }
          >
            <p>{moment(e.date).format('DD')}</p>
          </div>
          {eventCount.length > 0 && (
            <div className='total-Activities'>
              {eventCount.length} {countTitle}
            </div>
          )}
        </div>
      );
    }
    return undefined;
  };

  const renderCustomNowIndicator = () => (
    <div className='d-flex'>
      <div className='now-dot' />
      <div className='custom-now-line' />
    </div>
  );

  return (
    <div className='custom-calendar'>
      <div className='row'>
        <div className='col-md-6 d-flex justify-content-around align-items-center'>
          <span className='arrow-box' onClick={() => onDateChange('previous')}>
            <ArrowBackIcon className='arrow' />
          </span>
          <span className='custom-calendar-date'>{date.displayDate}</span>
          <span className='arrow-box' onClick={() => onDateChange('next')}>
            <ArrowForwardIcon className='arrow' />
          </span>
        </div>
        <div className='col-md-6 d-flex justify-content-end'>
          <Button
            className='me-4 py-2 dropdown-button'
            variant='outlined'
            color='secondary'
            size='medium'
          >
            <Select
              value={calendarType}
              onChange={(e) => handleViewChange(e.target.value)}
              className='custom-calendar-view-select'
              MenuProps={{ className: 'calendar-view-dropdown-list' }}
            >
              {CALENDAR_VIEW?.map((calendarView) => (
                <MenuItem key={calendarView.id} value={calendarView.id}>
                  {calendarView.name}
                </MenuItem>
              ))}
            </Select>
          </Button>
        </div>
      </div>
      <div className='mt-3'>
        <FullCalendar
          ref={calendarRef}
          plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
          initialView='timeGridDay'
          headerToolbar={null}
          allDaySlot={false}
          dayHeaders={displayDayHeader()}
          dayHeaderFormat={{
            weekday: calendarType === 'timeGridWeek' ? 'short' : 'long',
            day: calendarType === 'timeGridWeek' ? 'numeric' : undefined,
          }}
          dayHeaderContent={(e) => renderDayHeaderContent(e)}
          events={eventList}
          eventContent={(e) => renderEventContent(e)}
          slotEventOverlap={true}
          dayCellContent={(e) => renderDayCellContent(e)}
          nowIndicator={true}
          nowIndicatorContent={() => renderCustomNowIndicator()}
        />
      </div>
    </div>
  );
};

export default CustomCalendarView;
